export const SIGNUP: string = "/signup";
export const LOGIN: string = "/login";
export const LANDING: string = "/";
export const HOME: string = "/home";
export const PROFILE: string = "/profile";
export const FRIENDS: string = "/friends";
export const ACTIVITY: string = "/activity";
export const PUBLIC_ACTIVITY: string = "/activity/:publicUid";
export const PASSWORD_FORGET: string = "/password_forget";
export const MATCHES: string = "/matches";
export const MATCHES_FILTER: string = "/matches/:showOnly";
